import { reportsService } from "../services/reports.service";

const state = {}
const getters = {}

const actions = {
    async fetchGeneratedReports({ commit }, { pageSize, nextPageToken, type, searchQuery } = {}) {
        try {
            const generatedReports = await reportsService.fetchGeneratedReports({ pageSize, nextPageToken, type, searchQuery });
            return generatedReports;
        } catch (error) {
            return Promise.reject(error)
        }
    }
}

const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};